export default __webpack_public_path__ + "static/media/add.f3e3539c.svg";